import type { MouseEvent } from 'react';

import { IconButton } from 'design-system';
import { Download } from 'lucide-react';

import { toInlineStyle } from '@/features/_shared/lib/legacyStyle';

const ExportButton = ({
  title,
  disabled,
  handleClick,
  sx,
  iconSize = 16
}: {
  title: string;
  disabled?: boolean;
  handleClick: (event: MouseEvent) => void;
  sx?: unknown;
  iconSize?: number;
}) => (
  <IconButton
    disabled={disabled}
    label={title}
    style={toInlineStyle(sx)}
    onClick={handleClick}
  >
    <Download style={{ width: iconSize, height: iconSize }} />
  </IconButton>
);

export default ExportButton;
